export default function DropdownMenu({ children }) {
  return <div className="dropdown">{children}</div>;
}
